export default __webpack_public_path__ + "static/media/Rubbish - Grey.d6a0ef43.svg";